export default {
    'name': 'x-square',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M15 9L9 15\' stroke=\'#006CFD\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/><path d=\'M15 15L9 9\' stroke=\'#006CFD\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/><path d=\'M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z\' stroke=\'#006CFD\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/>'
}
